import PropTypes from 'prop-types';
import React from 'react';

import FieldsFactory1 from '../../../fields/fields-factory.ts';

import Classes from 'classnames';

class CustomFieldFormElement extends React.Component {
    static propTypes = {
        form: PropTypes.object.isRequired,
        name: PropTypes.string.isRequired,

        type: PropTypes.number,
        customFieldId: PropTypes.string,
        params: PropTypes.object.isRequired
    };

    UNSAFE_componentWillMount() {
        this.props.form.registerFormComponent(this.props.name,this);
    }

    onChange = (newValue) => {
        this.props.form.onFormComponentValueChange(this.props.name,newValue);
    };

    render() {
        const { type, params, className } = this.props;
        const { symbol, decimalPlaces, listItems } = params;

        const { form, name } = this.props;
        const customFieldValue = form.getValue(name);

        const classes = Classes("custom-field-form-element", className, "form-type");

        // let customField = <span/>;

        const Field = FieldsFactory1.get(this.props.customFieldId);
        const RenderComponent = Field.EditComponent;


        return <RenderComponent mode="edit" onChange={this.onChange} className={classes} vaue={customFieldValue} canEdit={true} />;

    }
}

module.exports = CustomFieldFormElement;
